import React from "react";

const principles = ["P1", "P2", "P3", "P4", "P5", "P6", "P7", "P8", "P9"];

const defaultReasonRows = [
  {
    question:
      "The entity does not consider the Principles material to its business",
    type: "toggle",
    values: {},
  },
  {
    question:
      "The entity is not yet in a position to create and implement policies based on the specified principles.",
    type: "toggle",
    values: {},
  },
  {
    question:
      "The entity does not have the financial or/human and technical resources available for the task",
    type: "toggle",
    values: {},
  },
  {
    question: "It is planned to be done in the next financial year",
    type: "toggle",
    values: {},
  },
  {
    question: "Any other reason (please specify)",
    type: "text",
    values: {},
  },
];

const PolicyGapReasonTable = ({ reasonData, setReasonData }) => {
  const handleToggleChange = (rowIdx, principle) => {
    const updated = [...reasonData];
    updated[rowIdx].values[principle] = !updated[rowIdx].values[principle];
    setReasonData(updated);
  };

  const handleTextChange = (rowIdx, principle, value) => {
    const updated = [...reasonData];
    updated[rowIdx].values[principle] = value;
    setReasonData(updated);
  };

  return (
    <div
      style={{
        marginTop: "20px",
        overflowX: "auto",
        maxWidth: "100%",
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: "12px",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th style={tableHeaderStyle}>Questions</th>
            {principles.map((p) => (
              <th key={p} style={tableHeaderStyle}>
                {p}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {reasonData.map((row, rowIdx) => (
            <tr key={rowIdx}>
              <td style={{ ...tableCellStyle, fontWeight: "bold" }}>
                {row.question}
              </td>
              {principles.map((principle) => (
                <td key={principle} style={tableCellStyle}>
                  {row.type === "toggle" ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "4px",
                        fontSize: "11px",
                      }}
                    >
                      <span>No</span>
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={row.values?.[principle] || false}
                          onChange={() => handleToggleChange(rowIdx, principle)}
                        />
                        <span className="slider round"></span>
                      </label>
                      <span>Yes</span>
                    </div>
                  ) : (
                    <textarea
                      placeholder="Details"
                      value={row.values?.[principle] || ""}
                      onChange={(e) =>
                        handleTextChange(rowIdx, principle, e.target.value)
                      }
                      style={textareaStyle}
                    />
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>

      {/* Toggle Switch CSS */}
      <style>{`
        .switch {
          position: relative;
          display: inline-block;
          width: 34px;
          height: 18px;
        }

        .switch input {
          opacity: 0;
          width: 0;
          height: 0;
        }

        .slider {
          position: absolute;
          cursor: pointer;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: #ccc;
          transition: .4s;
          border-radius: 24px;
        }

        .slider:before {
          position: absolute;
          content: "";
          height: 12px;
          width: 12px;
          left: 3px;
          bottom: 3px;
          background-color: white;
          transition: .4s;
          border-radius: 50%;
        }

        input:checked + .slider {
          background-color: #8a4a68;
        }

        input:checked + .slider:before {
          transform: translateX(14px);
        }
      `}</style>
    </div>
  );
};

// Styles
const tableHeaderStyle = {
  padding: "6px",
  border: "1px solid #000",
  textAlign: "center",
  fontSize: "12px",
};

const tableCellStyle = {
  padding: "6px",
  border: "1px solid #000",
  textAlign: "center",
  verticalAlign: "middle",
  fontSize: "12px",
};

const textareaStyle = {
  width: "90%",
  height: "60px",
  padding: "4px",
  borderRadius: "3px",
  border: "1px solid grey",
  fontSize: "12px",
  backgroundColor: "white",
  outline: "none",
  resize: "vertical",
};

export default PolicyGapReasonTable;
